import { Link as LinkChakra, LinkProps } from "@chakra-ui/react";

const Link = ({ ...rest }: LinkProps) => {
  return (
    <LinkChakra
      w={"fit-content"}
      _hover={{ transform: "none" }}
      _focus={{ border: 'none'}} 
      fontFamily="VivoType"
      fontWeight={"500"}
      fontSize={{base: "16px", lg: "18px"}}
      lineHeight={"24px"}
      color={"white.550"}
      {...rest}
    />
  );
};
export default Link;
